import React from "react";
import ButtonLoader from "./buttonLoader";
const Processer = ({ processingText }) => {
  return (
    <div className="row d-flex">
      <ButtonLoader />
      <h5> {processingText} </h5>
    </div>
  );
};

export default Processer;
